/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationQueryTargetCurrency extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("CurrencyExchangeConfigurationQueryTargetCurrency");
    }

    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationQueryTargetCurrency.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationQueryTargetCurrency>): CurrencyExchangeConfigurationQueryTargetCurrency {
        let obj = Object.assign(new CurrencyExchangeConfigurationQueryTargetCurrency(), model);
        CurrencyExchangeConfigurationQueryTargetCurrency.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationQueryTargetCurrency>): CurrencyExchangeConfigurationQueryTargetCurrency {
        if (!model) return null;
        return CurrencyExchangeConfigurationQueryTargetCurrency.newInstance(<CurrencyExchangeConfigurationQueryTargetCurrency> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationQueryTargetCurrency) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationQueryTargetCurrency.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationQueryTargetCurrency): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationQueryTargetCurrency.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Target Currencies for Currency Exchange Configuration
     */
    target_currencies: Array<string>;

}
